import classNames from 'classnames'
import React, { useEffect } from 'react'

import { PlainProduct } from '../hooks/useProducts'
import { gaEvents } from '../logic/ga4'

import ProductListItem from './product/ProductListItem'

const ProductWindow = ({
  products,
  className,
  centered = false,
}: React.PropsWithChildren<{
  className?: string
  centered?: boolean
  products: PlainProduct[]
  ProductComponent?: React.ComponentType<{
    className?: string
    product: PlainProduct
  }>
}>) => {
  useEffect(() => {
    gaEvents.productsShown('Product window', products)
  }, [])

  return (
    <div className="w-full">
      <div
        className={classNames(
          'flex w-0 min-w-full snap-x snap-mandatory gap-3 overflow-x-auto mask-r-from-90% pb-3',
          className,
        )}
      >
        {centered ? (
          <div className="shrink-1 grow-1 basis-1/10 snap-none" />
        ) : null}
        {products.map(p => (
          <ProductListItem
            className="min-h-50 shrink-0 basis-75 snap-center p-5! shadow-sm"
            key={p.id}
            product={p}
          />
        ))}
        <div className="shrink-0 grow-1 basis-1/10 snap-none" />
      </div>
    </div>
  )
}

export default ProductWindow
